export const notAvailableLabel = $localize`:Pulse|Pulse value not available label@@valueNotAvailable:n/a`;
